import * as React from 'react';
const { useCallback } = React;
import { bindActionCreators } from 'redux';

import { withAutoUpdate, IBusinessState } from '../../../../../flux';
import { tenantActionsPack } from '../../../actions';
import { tenantSelectorsPack } from '../../../selectors';
import XDeveloperZone from './developer-zone.view';


type DeveloperZoneProps = {
	isFetching?: boolean;
	token?: OAuthAccessToken;
	fetchAccessTokens?: () => void;
	generateAccessToken?: () => void;
	revokeAccessToken?: (tokenValue: string) => void;
};

const DeveloperZone: React.SFC<DeveloperZoneProps> = (props) => {
	const {
		isFetching,
		token,
		generateAccessToken,
		revokeAccessToken,
		...rest
	} = props;

	const handleRevokeAccessToken = useCallback(() => token && token.Value && revokeAccessToken(token.Value), [token]);

	return (
		<XDeveloperZone
			{...rest}
			isFetching={isFetching}
			token={token}
			onGenerateAccessToken={generateAccessToken}
			onRevokeAccessToken={handleRevokeAccessToken}
		/>
	);
}

function mapStateToProps(state): Partial<DeveloperZoneProps> {
	return {
		isFetching: tenantSelectorsPack.selectAsyncAccessTokens.selectIsFetching(state),
		token: tenantSelectorsPack.selectFirstAccessToken(state),
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		fetchAccessTokens: tenantActionsPack.actions.fetchAccessTokens,
		generateAccessToken: tenantActionsPack.actions.generateAccessToken,
		revokeAccessToken: tenantActionsPack.actions.revokeAccessToken,
	}, dispatch);
}

export default withAutoUpdate<IBusinessState, DeveloperZoneProps>(mapStateToProps, mapDispatchToProps)({
	tenantDidInvalidate: [
		tenantSelectorsPack.selectAsyncAccessTokens.selectDidInvalidate,
		({ fetchAccessTokens }) => fetchAccessTokens(),
	],
})(DeveloperZone);
